import { Box, Text, Center, createStyles, Button } from "@mantine/core";
import DocUploadSvg from "../../../components/Svgs/DocUploadSvg";
import UploadStaffDoc from "../../../components/StaffDetails/UploadStaffDoc";
import moment from "moment";
import {
  setSelectedDocModal,
  setUploadDocModal,
} from "../../../store/reducers/document";
import store from "../../../store";
import { decrypt } from "../../../utils";

const useStyles = createStyles(() => ({
  card: {
    borderRadius: "8px",
    padding: ".5rem",
    backgroundColor: "#f5f5f5",
  },
  title: {
    borderRadius: "4px",
    padding: "0.3rem",
    borderLeftWidth: "5px",
    borderLeftStyle: "solid",
  },
  noteCardTitle: {
    backgroundColor: "#FEF0C7",
    borderLeftColor: "#CC7914",
  },
  taskCardTitle: {
    backgroundColor: "#F6F0FF",
    borderLeftColor: "#D6BEF5",
  },
  medicationCardTitle: {
    backgroundColor: "#DCFFCC",
    borderLeftColor: "#1EA736",
  },
  documentCardTitle: {
    backgroundColor: "#E0F4FF",
    borderLeftColor: "#1791D3",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    gap: ".1rem",
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "0.5rem",
    borderColor: "#E5E5EA",
    borderWidth: "2px",
    borderStyle: "solid",
    marginTop: "0.5rem",
  },
  taskCard: {
    borderRadius: "10px",
    padding: ".5rem",
    backgroundColor: "#f5f5f5",
  },
  taskCardContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1rem",
  },
  fileName: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    borderRadius: "4px",
    border: "1px solid  #E7EBEF",
    background: "#F4F4F5",
    padding: "0.5rem",
  },
}));

const DocumentNotificationCard = ({ item }) => {
  const { classes } = useStyles();

  return (
    <Box key={item?.id} className={classes.card} mb="md">
      <Box className={`${classes.title} ${classes.documentCardTitle}`}>
        <Text ff="Inter" fz={12} fw={700}>
          Document
        </Text>
      </Box>

      <Box className={classes.body}>
        <Text ff="Inter" fz={24} fw={700}>
          {item?.facility?.name ||
                    (item?.client ? decrypt(item?.client?.name, false) : null) ||
                    item?.staff?.name ||
                    ""}
        </Text>

        <Text ff="Inter" fz={12} c="#A3A3A3" fw={500}>
          Document expired, please re-upload.
        </Text>
        <Text ff="Inter" fz={12} c="#A3A3A3" fw={500} tt="capitalize">
          Expiry Date: {moment(item?.expiry).format("MM-DD-YYYY")}
        </Text>
        <Box className={classes.fileName}>
          <DocUploadSvg />
          <Text ff="Inter" fz={12} c="#A3A3A3" fw={500}>
            {item?.name ? item.name : "-"}
          </Text>
        </Box>

        <Center mt="sm">
          {/* <UploadStaffDoc
            selectedFolder={item?.folder}
            userId={item?.userId}
            isPendingAction={true}
            uploadedFiles={item?.file}
          /> */}
          <Button
            variant="white"
            c="#000"
            ff="Inter"
            fz={12}
            fw={500}
            onClick={() => {
              store.dispatch(setSelectedDocModal({...item, userId: item?.client?.id || item?.staff?.id || item?.facility?.id}));
              store.dispatch(setUploadDocModal(true));
            }}
          >
            View Details
          </Button>
        </Center>
      </Box>
    </Box>
  );
};

export default DocumentNotificationCard;

// export function DocumentNotifications({ notifications }) {
//   const { classes } = useStyles();

//   return (
//     <>
//       {notifications?.map((n) => {
//         return (
//           <Box key={n.id} className={classes.card} mb="md">
//             <Box className={`${classes.title} ${classes.documentCardTitle}`}>
//               <Text ff="Inter" fz={12} fw={700}>
//                 Document
//               </Text>
//             </Box>

//             <Box className={classes.body}>
//               <Text ff="Inter" fz={24} fw={700}>
//                 {n?.name}
//               </Text>

//               <Text ff="Inter" fz={12} c="#A3A3A3" fw={500}>
//                 {`Document expired,  please re-upload.`}
//               </Text>
//               <Text ff="Inter" fz={12} c="#A3A3A3" fw={500} tt="capitalize">
//                 {`Expiry Date: ${moment(n?.file?.expiry).format("DD-MM-YYYY")}`}
//               </Text>
//               <Box className={classes.fileName}>
//                 <DocUploadSvg />
//                 <Text ff="Inter" fz={12} c="#A3A3A3" fw={500}>
//                   {n?.file?.name}
//                 </Text>
//               </Box>

//               <Center mt="sm">
//                 <UploadStaffDoc
//                   selectedFolder={n?.folder}
//                   userId={n?.userId}
//                   isPendingAction={true}
//                   uploadedFiles={n?.file}
//                 />
//               </Center>
//             </Box>
//           </Box>
//         );
//       })}
//     </>
//   );
// }
